import { Component, OnInit } from '@angular/core';
import { AlertItem, AlertType } from 'src/app/core/models';
import { AlertService, ModalService } from 'src/app/core/services';
import { AdministrativeService } from 'src/app/core/services/administrative.service';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { AdminPermissionI18n } from '../permissions/permissions.component';

@Component({
  selector: 'app-edit-admin-permission-modal',
  templateUrl: './edit-admin-permission-modal.component.html',
  styleUrls: ['./edit-admin-permission-modal.component.sass']
})
export class EditAdminPermissionModalComponent extends BaseModal implements OnInit {
  get isValid(): boolean {
    throw new Error('Method not implemented.');
  }
  get lastState(): any {
    throw new Error('Method not implemented.');
  }

  public loading = false;
  public initialState: any;
  public promise: Promise<any>;
  public permissionI18n = AdminPermissionI18n;

  public permissionItems: Array<{
    key: string;
    itemName: string;
    isOpen: boolean;
    permissions: Array<{
      id: number;
      relationId: number;
      permissionId: number;
      userId: number;
      permissionName: string;
      checked: boolean;
    }>;
  }> = [
      { key: 'Contract', itemName: 'Gerenciamento de Contrato', isOpen: false, permissions: [] },
      { key: 'Company', itemName: 'Gerenciamento de Empresas', isOpen: false, permissions: [] },
      { key: 'Appraisal', itemName: 'Gerenciamento de Certificado de Aferição', isOpen: false, permissions: [] }
    ];

  constructor(
    modalService: ModalService,
    public administrativeService: AdministrativeService,
    private alertService: AlertService,
  ) {
    super(modalService);
  }

  async ngOnInit() {
    await this.setPermissions();
  }

  openOrClone(permissionItem) {
    permissionItem.isOpen = !permissionItem.isOpen;
  }

  async setPermissions() {
    const userAdminPermissions = this.initialState?.user?.UserAdminPermissions;
    this.loading = true;
    const adminPermissions = await this.administrativeService.listAdminPermissions();

    for (const a of adminPermissions) {
      a.checked = this.checkPermission(a);
    }

    for (const adminPermission of adminPermissions) {
      if (adminPermission.name.includes('Contract')) {
        this.permissionItems.find(a => a.key === 'Contract').permissions.push(adminPermission);
      }
      if (adminPermission.name.includes('Company')) {
        this.permissionItems.find(a => a.key === 'Company').permissions.push(adminPermission);
      }
      if (adminPermission.name.includes('Appraisal')) {
        this.permissionItems.find(a => a.key === 'Appraisal').permissions.push(adminPermission);
      }
    }

    this.loading = false;
  }

  checkPermission(permItem) {
    const userAdminPermissions = this.initialState.user.UserAdminPermissions;
    const hasPermission = userAdminPermissions.find(a => a.adminPermissionId === permItem.id);
    if (hasPermission !== undefined) {
      permItem.checked = true;
      return true;
    }
    permItem.checked = false;
    return false;
  }

  changePermission(permissionItem, permItem) {
    this.permissionItems = this.permissionItems.map(item => {

      if (item.key !== permissionItem.key) { return item; }

      // Toggle da permissão clicada
      const toggledValue = !permItem.checked;

      let updatedPermissions = item.permissions.map((p: any) =>
        p.id === permItem.id
          ? { ...p, checked: toggledValue }
          : p
      );

      const isViewPermission = permItem.name.includes('View');

      // Se desmarcar View → desmarca tudo
      if (isViewPermission && !toggledValue) {
        updatedPermissions = updatedPermissions.map(p => ({
          ...p,
          checked: false
        }));
      }

      // Se marcar Create/Update/Delete → marca View
      if (!isViewPermission && toggledValue) {
        updatedPermissions = updatedPermissions.map(p =>
          p.name.includes('View')
            ? { ...p, checked: true }
            : p
        );
      }

      return {
        ...item,
        permissions: updatedPermissions
      };
    });
  }

  onAllSubmited(): Promise<any> {
    this.loading = true;
    let success = false;
    try {
      const userId = this.initialState.user.id;
      const permissionsForAdd = this.permissionItems
        .map(a => a.permissions.filter(b => b.checked));

      for (const keyforAdd of permissionsForAdd) {
        keyforAdd.forEach(async itemForAdd => {
          const userAdminPermissions = this.initialState.user.UserAdminPermissions;
          const hasPermission = userAdminPermissions.find(a => a.adminPermissionId === itemForAdd.id);
          if (hasPermission === undefined) {
            // add permission
            await this.administrativeService.addAdminPermissionIntoUser(userId, itemForAdd.id);
          }
        });
      }

      const permissionsForRemove = this.permissionItems
        .map(a => a.permissions.filter(b => b.checked === false));

      for (const keyforRemove of permissionsForRemove) {
        keyforRemove.forEach(async itemForRemove => {
          const userAdminPermissions = this.initialState.user.UserAdminPermissions;
          const hasPermission = userAdminPermissions.find(a => a.adminPermissionId === itemForRemove.id);
          if (hasPermission !== undefined) {
            // remove permission
            await this.administrativeService.removeRelationUserAdminPermission(hasPermission.id);
          }
        });
      }
      success = true;
      return this.promise;
    } catch (error) {
      this.alertService.show(new AlertItem('GenericError', AlertType.danger));
    } finally {
      if (success) {
        this.alertService.show(new AlertItem('AdminPermissionsUpdated', AlertType.success));
      }
      setTimeout(() => {
        location.reload();
        this.loading = false;
      }, 2000);
    }
  }
}
